import React from 'react';
import '../App.css';

function Anon(){


  return(
    <div className="center" >
      <h1 className="title">Welcome to ODE</h1>
      <h2 className="title">The Online Dialogue Experiment WebApp</h2>
        <p>On this page, I run web experiments with virtual avatars. </p>
        <p>If you want to know more, click on FAQ. </p>
        <p>Should you wish to participate, please click the Sign Up button.</p>
    </div>
  )
}

export default Anon
